import Page from "~/components/Page";
import TableControls from "~/components/TableControls";
import ApproveTransactionModal from "~/modals/ApproveTransactionModal";
import AdminTransactionsTable from "~/tables/AdminTransactionsTable";
import { useTrans } from '~/hooks/useTrans';
import { apiGetTransactions } from "~/providers/api";
import { ITransactionApproval } from "~/providers/interfaces";
import ErrorInfo from '~/components/ErrorInfo';
import { myUseState } from "~/hooks/myUseState";
import { useLang } from "~/hooks/useLang";

interface IState {
	loading: boolean;
	isDirty: boolean;
	transactions: Array<ITransactionApproval>;
	errorMsg: string;
	approveTransaction: ITransactionApproval | null;
}

const INIT_STATE: IState = {
	loading: true,
	isDirty: false,
	transactions: [],
	errorMsg: "",
	approveTransaction: null,
};

export default function AdminTransactionsPage() {
	const { trans } = useTrans();
	const { lang } = useLang();
	const { state, updateState } = myUseState<IState>(INIT_STATE);

	async function loadData() {
		updateState(INIT_STATE);

		const transactionsData = await apiGetTransactions(lang);

		updateState({
			loading: false,
			...transactionsData.noErrors
				? {
					transactions: transactionsData.data,
				}
				: {},
			errorMsg: transactionsData.errors.join(", "),
		});
	}

	function onTransactionSave() {
		updateState({
			approveTransaction: null,
		});
		loadData();
	}

	function onPageLoad(isAuthorized: boolean) {
		if (isAuthorized) {
			loadData();
		}
	}

	return <Page title={trans("menu.adminTransactions")} breadcrumbs={[trans("administration"), trans("menu.adminTransactions")]} checkInternalRole="internal_admin" onLoad={onPageLoad} isDirty={state.isDirty} seoTitleTrans="seo.title.admin.transactions">
		{ state.errorMsg && <ErrorInfo msg={state.errorMsg} className="margin-top-large" /> }
		<TableControls className="adminServicesPage__tableControls">
			<div></div>
		</TableControls>
		<AdminTransactionsTable loading={state.loading} items={state.transactions} onApprove={approveTransaction => updateState({ approveTransaction })} />
		{ state.approveTransaction && <ApproveTransactionModal transaction={state.approveTransaction} onSave={onTransactionSave} onClose={() => updateState({ approveTransaction: null })} /> }
	</Page>;
}
